module.exports = "/static/Images/Roboto/Roboto-BoldItalic.ttf";